export default __webpack_public_path__ + "static/media/slideCampaign-2.b03dff86.png";